import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files by feature
import commonEn from './translations/en/common.json';
import authEn from './translations/en/auth.json';
import dashboardEn from './translations/en/dashboard.json';
import userEn from './translations/en/user.json';
import inventoryEn from './translations/en/inventory.json';
import profileEn from './translations/en/profile.json';

import commonEs from './translations/es/common.json';
import authEs from './translations/es/auth.json';
import dashboardEs from './translations/es/dashboard.json';
import userEs from './translations/es/user.json';
import inventoryEs from './translations/es/inventory.json';
import profileEs from './translations/es/profile.json';

// Get initial language from localStorage or default to English
// This will be overridden by LanguageContext based on user preference
const initialLanguage = localStorage.getItem('language') || 'en';

const resources = {
  en: {
    common: commonEn,
    auth: authEn,
    dashboard: dashboardEn,
    user: userEn,
    inventory: inventoryEn,
    profile: profileEn
  },
  es: {
    common: commonEs,
    auth: authEs,
    dashboard: dashboardEs,
    user: userEs,
    inventory: inventoryEs,
    profile: profileEs
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'en',
    
    // Configure namespaces
    ns: ['common', 'auth', 'dashboard', 'user', 'inventory', 'profile'],
    defaultNS: 'common',
    
    interpolation: {
      escapeValue: false // React already does escaping
    },
    
    // Optional: Add debug mode for development
    debug: process.env.NODE_ENV === 'development',
    
    // Configure how keys are structured
    keySeparator: '.',
    nsSeparator: ':',
    
    // Save language preference when changed
    saveMissing: true,
    
    // React specific options
    react: {
      useSuspense: false
    }
  });

// Save language preference when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;